var map = {
	"./Home": 3140,
	"./Home.jsx": 3140,
	"./Home2": 6205,
	"./Home2.jsx": 6205,
	"./Yellow.png": 2024,
	"./background.jpg": 7016,
	"./chat-bot.png": 3592,
	"./exampleCertificate.jpg": 4609,
	"./exampleCertificate2.png": 2827,
	"./first.png": 7128,
	"./flights.jpeg": 6120,
	"./header.jpg": 2707,
	"./home.scss": 1994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4287;